import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { UserMessagesPage } from './user-messages';

@NgModule({
  declarations: [UserMessagesPage],
  imports: [IonicPageModule.forChild(UserMessagesPage)],
})
export class UserMessagesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/user-messages/user-messages.module.ts